import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Layout } from './components/Layout';
import { useAuthStore } from './store/authStore';
import { useThemeStore } from './store/themeStore';
import { createAppTheme } from './theme';
import { Login } from './pages/Login';
import { Cases } from './pages/Cases';
import { CaseDetails } from './pages/CaseDetails';
import { CaseIntake } from './pages/CaseIntake';
import { Documents } from './pages/Documents';
import { Reports } from './pages/Reports';
import { Messages } from './pages/Messages';
import { TaskTemplates } from './pages/TaskTemplates';
import { Users } from './pages/Users';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuthStore();
  if (!user) return <Navigate to="/login" />;
  return <>{children}</>;
};

export default function App() {
  const { mode } = useThemeStore();
  const theme = React.useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route path="/cases" element={<Cases />} />
                      <Route path="/case-intake" element={<CaseIntake />} />
                      <Route path="/cases/:id" element={<CaseDetails />} />
                      <Route path="/documents" element={<Documents />} />
                      <Route path="/task-templates" element={<TaskTemplates />} />
                      <Route path="/reports" element={<Reports />} />
                      <Route path="/messages" element={<Messages />} />
                      <Route path="/users" element={<Users />} />
                      <Route path="/" element={<Navigate to="/cases" />} />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </LocalizationProvider>
    </ThemeProvider>
  );
}